import { defineRouting } from "next-intl/routing";
import { createNavigation } from "next-intl/navigation";
import { ja, enUS, zhTW, zhCN, ko } from "date-fns/locale";
import { Locale as LocaleFns } from "date-fns";

export const LOCALES = ["ja", "en-us", "zh-cn","zh-tw", "ko-kr"];
export const DEFAULT_LOCALE = "ja";
// Default placeholder shown by the language selector instead of the active locale
// name. Always rendered in English on every locale, so every usage must carry
// `data-wovn-ignore` to keep WOVN from translating it.
export const LOCALE_SELECT_PLACEHOLDER = "Select Language";
export const LOCALE_NAMES: Record<string, string> = {
  "en-us": "English",
  "zh-tw": "繁體中文",
  "zh-cn": "简体中文",
  ja: "日本語",
  "ko-kr": "한국어",
};
export const LOCALE_API_MAP: Record<string, string> = {
  ja: "ja",
  "en-us": "en",
  "zh-tw": "zh-Hant-TW",
  "zh-cn": "zh",
  "ko-kr": "ko",
};
export const LOCALE_WOVN: Record<string, string> = {
  ja: "ja",
  "en-us": "en",
  "zh-tw": "zh-CHT",
  "zh-cn": "zh-CHS",
  "ko-kr": "ko",
};
export const LOCALE_BASE_MAP: Record<string, string> = {
  ja: "ja",
  "en-us": "en",
  "zh-tw": "zh",
  "zh-cn": "zh",
  "ko-kr": "ko",
};

export const LOCALE_WOVN_TO_STRAPI: Record<string, string> = {
  ja: "ja",
  en: "en",
  ko: "ko",
  "zh-CHT": "zh-Hant-TW",
  "zh-CHS": "zh",
};

export const LOCALE_WOVN_TO_TRIPLA: Record<string, string> = {
  ja: "ja",
  en: "en",
  ko: "ko",
  "zh-CHT": "zh",
  "zh-CHS": "zh",
};

export const DATE_FNS_LOCALE_MAP: Record<string, LocaleFns> = {
  ja: ja,
  "en-us": enUS,
  "zh-tw": zhTW,
  "zh-cn": zhCN,
  "ko-kr": ko,
};

export function mapLocaleToApiFormat(locale: string): string {
  return LOCALE_API_MAP[locale] || locale;
}

export function mapLocaleWovnToStrapi(locale: string): string {
  return LOCALE_WOVN_TO_STRAPI[locale] || locale;
}

export function mapLocaleWovnToTripla(locale: string): string {
  return LOCALE_WOVN_TO_TRIPLA[locale] || locale;
}

export const routing = defineRouting({
  locales: LOCALES,
  defaultLocale: DEFAULT_LOCALE,
  localeDetection: false,
  localePrefix: "as-needed",
});

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);

export type Locale = (typeof routing.locales)[number];
